import { render, staticRenderFns } from "./TableMenu.vue?vue&type=template&id=8b00192e&scoped=true&"
import script from "./TableMenu.vue?vue&type=script&lang=ts&"
export * from "./TableMenu.vue?vue&type=script&lang=ts&"
import style0 from "./TableMenu.vue?vue&type=style&index=0&id=8b00192e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b00192e",
  null
  
)

export default component.exports